<template>
  <div>
    <PageHeader :title="title" :items="headerItems" />
    <div class="main mb-4 addProductMainDiv" ref="addProductMainDiv">
      <b-row>
        <b-col cols="4" class="right__section">
          <div class="inner__style m_b_20">
            <div class="m_b_20" v-if="this.$route.params.id">
              <BaseText :disable="true" @input="productUniqeId = $event" :value="productUniqeId" title="شناسه محصول" placeholder="شناسه محصول" />
            </div>
            <div class="m_b_20" v-if="!this.$route.params.id">
              <ComboBox
                @loadMoreData="loadMoreCategories"
                @searchedItem="searchedCategory"
                :searchedData="mainCategories"
                @selectedItem="getCategoryChilds($event)"
                :selectedValue="selectedGrandCategory"
                pagination
                placeholder="دسته بندی"
                title="دسته بندی"
              />
            </div>
            <div v-else class="m_b_20">
              <span v-for="item in categoryParents" :key="item"> {{ item }} /</span>
              <span> {{ editCategoryName }}</span>
            </div>
            <div class="m_b_20" v-for="(item, index) in childrenCategory" :key="item.value">
              <ComboBox
                @loadMoreData="subCategoriesWithPagination(index)"
                @searchedItem="searchedChildrenCategory($event, index)"
                :searchedData="childrenCategory[index].arr"
                @selectedItem="getChildren($event, index)"
                :selectedValue="childrensComboValue[index] ? childrensComboValue[index].name : ''"
                pagination
                placeholder="زیر دسته"
                title="زیر دسته"
              />
            </div>
            <div class="">
              <ComboBox
                @loadMoreData="loadMoreBrands"
                @searchedItem="searchedBrands"
                :searchedData="brandsData"
                @selectedItem="selectedBrand = $event"
                :selectedValue="selectedBrand.value"
                pagination
                placeholder="برند محصول"
                title="برند محصول"
                :hasButton="true"
                buttonText="اضافه کردن برند جدید"
                @buttonAction="$bvModal.show('AddBrandModal')"
                required
                :showError="brandError"
                errortext="وارد کردن برند الزامی است"
              />
            </div>
          </div>
          <div class="inner__style m_b_20 d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <input type="checkbox" id="checkbox-productIsActive" v-model="showProduct" name="checkbox-productIsActive" />
              <span for="checkbox-productIsActive" class="checkbox-margin">نمایش محصول</span>
            </div>
            <div v-if="this.$route.params.id">
              <div class="d-flex align-items-center justify-content-between remove-product-button" @click="$bvModal.show('deleteCategoryModal')">
                <i class="far fa-times-circle m_l_7"></i>
                <div>حذف محصول</div>
              </div>
            </div>
          </div>
          <div class="inner__style">
            <div
              v-if="imageSource.length === 0"
              :class="{ border__error: imageErrorFlag }"
              class="upload-photo-icon d-flex mx-auto justify-content-center align-items-center"
              @click="$bvModal.show('cropperModal')"
            >
              <div>
                <i class="fas fa-cloud-upload-alt icon-size"></i>
                <div class="upload-text-size">برای آپلود عکس خود کلیک کنید</div>
              </div>
            </div>
            <div v-else class="grand-parent">
              <div class="upload-photo-parent">
                <div
                  v-for="(source, index) in imageSource"
                  :key="source"
                  class="uploaded-photo"
                  @click="setActiveImage(index)"
                  :class="activeImage === source ? 'activeImageClass' : ''"
                >
                  <div class="remove-icon" @click="removeImage(index)">
                    <i class="fa fa-times"></i>
                  </div>
                  <img class="previewImage" :src="source" />
                </div>
                <div @click="$bvModal.show('cropperModal')" class="uploaded-photo addNewImageIconContainer">
                  <i class="fa fa-plus"></i>
                </div>
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="8" class="left__section" ref="leftSection">
          <div class="inner__style">
            <div>
              <div class="d-flex align-items-center mb-3 p-0">
                <div class="d-flex align-items-center">
                  <span class="sectionTitle">اطلاعات محصول</span>
                </div>
                <div class="line"></div>
              </div>
              <div class="section">
                <div class="mb-3">
                  <BaseText
                    :required="true"
                    :showError="productCodeError"
                    errortext="وارد کردن کد محصول اجباری است"
                    @input="productId = $event"
                    :value="productId"
                    title="کد محصول"
                    placeholder="کد محصول"
                  />
                </div>
                <div>
                  <BaseText
                    :required="true"
                    :showError="productTitleError"
                    errortext="وارد کردن عنوان محصول الزامی است"
                    @input="productTitle = $event"
                    :value="productTitle"
                    title="عنوان محصول"
                    placeholder="عنوان محصول"
                  />
                </div>
              </div>
            </div>
            <div>
              <div class="d-flex align-items-center mb-3 p-0">
                <div class="d-flex align-items-center">
                  <span class="sectionTitle">خلاصه محصول</span>
                </div>
                <div class="line"></div>
              </div>
              <div class="section">
                <div class="">
                  <TextAreaInput :maxlength="150" textAreaClass="align-items-center" :value="productNote" @input="productNote = $event" title="خلاصه محصول" />
                </div>
              </div>
            </div>
            <div>
              <div class="d-flex align-items-center mb-3 p-0">
                <div class="d-flex align-items-center">
                  <span class="sectionTitle">نقد و بررسی</span>
                </div>
                <div class="line"></div>
              </div>
              <div class="section">
                <div class="">
                  <editorTextArea :key="editorKey" @input="productStory = $event" :value="productStory" title="نقد و بررسی" textAreaClass="align-items-center" />
                </div>
              </div>
            </div>
          </div>
          <div class="inner__style mt-4">
            <div v-if="tableView">
              <div class="d-flex align-items-center justify-content-between">
                <div class="count__title">لیست موجودی</div>
                <Button @click.native="changeStockTableView" text="موجودی جدید" :hasIcon="true" btnStyle="width: 148px" />
              </div>
              <div class="count__content__container">
                <div class="count__empty__section" v-if="tableData === null">
                  <img src="@/assets/images/product-alert-icon.svg" alt="" />
                  <div>هنوز لیست موجودی ثبت نشده است</div>
                </div>
                <div v-else>
                  <Table @selectedRow="stockTableRowSelected($event)" :fields="tableData.fields" :rows="tableData.rows" noNeedToChangeRoute v-if="showTable" />
                  <!-- @selectedRow="" -->
                  <Pagination :tableId="tableId" :paginationData="tableData.pagination" @tableObj="updateTable($event)" :dropDownListItems="dropDownListItems" />
                </div>
              </div>
            </div>
            <div v-else>
              <div>
                <div class="d-flex align-items-center mb-3 p-0">
                  <div class="d-flex align-items-center">
                    <span class="sectionTitle">تامین موجودی</span>
                  </div>
                  <div class="line"></div>
                </div>
                <div class="section">
                  <div class="m_b_20" v-if="hasColor">
                    <ComboBox
                      @loadMoreData="loadMoreColors"
                      @searchedItem="searchedColors"
                      :searchedData="colorsData"
                      @selectedItem="selectedColor = $event"
                      :selectedValue="selectedColor.value"
                      pagination
                      placeholder="رنگ"
                      :disabled="isEditing"
                      :isColor="true"
                      title="رنگ"
                      :hasButton="true"
                      buttonText="اضافه کردن رنگ جدید"
                      @buttonAction="showModalOfProperty('addColorModal')"
                      required
                      :showError="colorError"
                      errortext="وارد کردن رنگ محصول اجباری است"
                    />
                  </div>
                  <div class="m_b_20" v-if="hasGuarantee">
                    <ComboBox
                      @loadMoreData="loadMoreGuarantees"
                      @searchedItem="searchedGuarantees"
                      :searchedData="guaranteesData"
                      @selectedItem="selectedGuarantee = $event"
                      :selectedValue="selectedGuarantee.value"
                      pagination
                      placeholder="گارانتی"
                      :disabled="isEditing"
                      :isColor="true"
                      title="گارانتی"
                      :hasButton="true"
                      buttonText="اضافه کردن گارانتی جدید"
                      @buttonAction="showModalOfProperty('addGuaranteeModal')"
                      required
                      :showError="guaranteesError"
                      errortext="وارد کردن گارانتی محصول اجباری است"
                    />
                  </div>
                  <div class="m_b_20" v-if="hasSize">
                    <ComboBox
                      @loadMoreData="loadMoreSize"
                      @searchedItem="searchedSize"
                      :searchedData="sizesData"
                      @selectedItem="selectedSize = $event"
                      :selectedValue="selectedSize.value"
                      pagination
                      placeholder="سایز"
                      :disabled="isEditing"
                      :isColor="true"
                      title="سایز"
                      :hasButton="true"
                      buttonText="اضافه کردن سایز جدید"
                      @buttonAction="showModalOfProperty('addSizeModal')"
                      required
                      :showError="sizeError"
                      errortext="وارد کردن سایز محصول اجباری است"
                    />
                  </div>
                  <div class="m_b_20">
                    <PriceInput
                      @input="stockQty = $event"
                      :value="stockQty"
                      title="موجودی"
                      :required="true"
                      :showError="stockQtyError"
                      errortext="وارد کردن موجودی الزامی است"
                      inputType="text"
                      placeholder="موجودی"
                      maxlength="20"
                    />
                  </div>
                  <div class="m_b_20">
                    <PriceInput
                      @input="productPrice = $event"
                      :value="productPrice"
                      :required="true"
                      :showError="productPriceError"
                      errortext="وارد کردن قیمت الزامی است"
                      title="قیمت فروش"
                      placeholder="قیمت فروش  (تومان) "
                      maxlength="20"
                    />
                  </div>
                  <!-- <div class="m_b_20">
                    <ComboBox
                      @loadMoreData="loadMoreProvider"
                      @searchedItem="searchedProvider"
                      :searchedData="providerData"
                      @selectedItem="selectedProvider = $event"
                      :selectedValue="selectedProvider.value"
                      pagination
                      placeholder="تامین کننده"
                      :disabled="isEditing"
                      :isColor="true"
                      title="تامین کننده"
                      required
                      :showError="providerError"
                      errortext="وارد کردن تامین کننده محصول اجباری است"
                    />
                  </div> -->
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <div class="d-flex align-items-center">
                        <input v-model="productStockActive" type="checkbox" id="checkbox-productIsActive" name="checkbox-productIsActive" />
                        <span for="checkbox-productIsActive" class="checkbox-margin">فعال کردن موجودی</span>
                      </div>
                    </div>
                    <div class="d-flex justify-content-between align-items-center">
                      <b-button @click="cancleStock" class="cancleButton">
                        <span class="cancleTitle">انصراف</span>
                      </b-button>
                      <Button @click.native="addNewStockToTable()" text="ثبت" btnClass="ms-2 btn-border aprove" :loading="btnLoading" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="inner__style mt-4" v-if="!showFormBuilder && formBuilderData !== null">
            <div>
              <div class="d-flex align-items-center mb-3 p-0">
                <div class="d-flex align-items-center">
                  <span class="sectionTitle">اطلاعات تکمیلی</span>
                </div>
                <div class="line"></div>
              </div>
              <div class="count__empty__section">
                <img src="@/assets/images/product-alert-icon.svg" alt="" />
                <div>لطفا دسته بندی را انتخاب کنید</div>
              </div>
            </div>
            <div class="buttonClass" v-if="formBuilderData === null || !showFormBuilder">
              <Button type="submit" @click.native="submit" text="ثبت و به روز رسانی" btnClass="ms-2 aprove btn-border" :loading="submitLoading" />
            </div>
          </div>
          <div class="inner__style mt-4" v-else>
            <div>
              <formBuilder
                :stopLoading="stopProductLoading"
                :isProduct="true"
                @productFormSubmited="submit($event)"
                :componentData="formBuilderData"
                :mainData="formBuilderData"
                :key="formbuilderKey"
              />
              <div class="buttonClass" v-if="formBuilderData === null">
                <Button type="submit" @click.native="submit" text="ثبت و به روز رسانی" btnClass="ms-2 aprove btn-border" :loading="submitLoading" />
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-modal size="md" id="AddBrandModal" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" title="اضافه کردن برند">
        <div>
          <div class="mt-3 mb-4 d-flex align-items-end">
            <img v-if="!brandImage" src="@/assets/images/brandDefaultPicture.svg" />
            <img class="new__brand__image" v-else :src="brandImage" />
            <b-button class="add__brand__pic" @click="$bvModal.show('brandCropperModal')">انتخاب عکس</b-button>
          </div>
          <div class="mt-2 mb-3">
            <BaseText @input="newBrandName = $event" :value="newBrandName" title="عنوان برند" placeholder="عنوان برند" />
          </div>
          <div class="buttonClass">
            <Button @click.native="createNewBrand()" text="ثبت" btnClass="ms-2 btn-border aprove" :loading="brandBtnLoading" />
            <b-button @click="$bvModal.hide('AddBrandModal')" class="cancleButton">
              <span class="cancleTitle">انصراف</span>
            </b-button>
          </div>
        </div>
      </b-modal>
      <b-modal id="cropperModal" no-close-on-esc hide-footer centered size="md" header-close-variant="dark" cancel-title>
        <template #modal-title>کراپ عکس</template>
        <div class="p-3">
          <ImageCropper :cropperLoading="cropperLoading" @imageSourceChanged="addImageToListOfImages($event)" />
        </div>
      </b-modal>
      <b-modal id="categorySelectError" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
        <div class="error-wrapper p-3">
          <div class="mb-4 text-center">
            <img src="@/assets/images/checked1.svg" />
          </div>
          <div class="error-title text-center" style="font-size: 15px">لطفا دسته بندی مورد نظر را ابتدا انتخاب کنید و لیست موجودی را بررسی نمایید.</div>
          <div class="mt-3 float-right w-100">
            <div class="d-flex align-items-center justify-content-center mx-3">
              <b-button class="col-6" style="background-color: #74788d; color: white; font-size: 13px" variant="secondary" block @click="$bvModal.hide('categorySelectError')"
                >انصراف</b-button
              >
              <b-button class="ms-2 col-6" style="background-color: #556ee6; color: white; font-size: 13px" variant="primary" block @click="$bvModal.hide('categorySelectError')"
                >متوجه شدم</b-button
              >
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal id="brandCropperModal" no-close-on-esc hide-footer centered size="md" header-close-variant="dark" cancel-title>
        <div class="p-3">
          <ImageCropper :cropperLoading="cropperLoadingBrand" @imageSourceChanged="getBrandImage($event)" />
        </div>
      </b-modal>
      <b-modal id="errorModal" no-close-on-esc hide-footer centered size="md" header-close-variant="dark" cancel-title>
        <div class="p-3">
          <ImageCropper :cropperLoading="cropperLoading" @imageSourceChanged="addImageToListOfImages($event)" />
        </div>
      </b-modal>
      <b-modal class="addColorModal" id="addColorModal" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
        <template #modal-title>اضافه کردن رنگ</template>
        <div class="">
          <div class="">
            <div class="mb-3">
              <BaseText @input="addColorName = $event" labelClass="addColorClass" :value="addColorName" title="نام" placeholder="نام" />
            </div>
            <div class="mb-3">
              <ColorPicker @input="addSelectedColor = $event" labelClass="addColorClass" :value="addSelectedColor" title="رنگ" />
            </div>
            <div class="buttonClass">
              <Button @click.native="createNewColor()" text="ثبت" btnClass="ms-2 btn-border aprove" :loading="colorBtnLoading" />
              <b-button @click="$bvModal.hide('addColorModal')" class="cancleButton">
                <span class="cancleTitle">انصراف</span>
              </b-button>
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal id="addSizeModal" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
        <template #modal-title>اضافه کردن سایز</template>
        <div>
          <div class="mb-3">
            <BaseText @input="addSizeName = $event" labelClass="addColorClass" :value="addSizeName" title="سایز" placeholder="سایز" />
          </div>
          <div class="buttonClass">
            <Button @click.native="createNewSize()" text="ثبت" btnClass="ms-2 btn-border aprove" :loading="sizeBtnLoading" />
            <b-button @click="$bvModal.hide('addSizeModal')" class="cancleButton">
              <span class="cancleTitle">انصراف</span>
            </b-button>
          </div>
        </div>
      </b-modal>
      <b-modal id="addGuaranteeModal" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
        <template #modal-title>اضافه کردن گارانتی</template>
        <div>
          <div class="mt-3 mb-4 d-flex align-items-end">
            <img v-if="guaranteeImage.length === 0" src="@/assets/images/brandDefaultPicture.svg" />
            <div v-else class="d-flex">
              <img class="new__brand__image" :src="guaranteeImage[0]" />
              <div v-if="guaranteeImage.length === 1" class="d-flex justify-content-center align-items-center plus__button__add__guararntee new__brand__image ms-3">
                <i @click="$bvModal.show('guaranteeCropperModal')" style="font-size: 40px" class="fa fa-plus"></i>
              </div>
              <img v-else-if="guaranteeImage.length > 1" class="new__brand__image ms-3" :src="guaranteeImage[1]" />
            </div>
            <b-button v-if="guaranteeImage.length === 0" class="add__brand__pic" @click="$bvModal.show('guaranteeCropperModal')">انتخاب عکس</b-button>
          </div>
          <div class="mb-3">
            <BaseText @input="addGuaranteeName = $event" labelClass="addColorClass" :value="addGuaranteeName" title="نام" placeholder="نام" />
          </div>
          <div class="mb-3">
            <BaseText
              inputType="number"
              @input="addGuaranteeDuaration = $event"
              labelClass="addColorClass"
              :value="addGuaranteeDuaration"
              title="مدت زمان (ماه)"
              placeholder="مدت زمان (ماه)"
            />
          </div>
          <div class="buttonClass">
            <Button @click.native="createNewGuarantee()" text="ثبت" btnClass="ms-2 btn-border aprove" :loading="guranteeBtnLoading" />
            <b-button @click="$bvModal.hide('addGuaranteeModal')" class="cancleButton">
              <span class="cancleTitle">انصراف</span>
            </b-button>
          </div>
        </div>
      </b-modal>
      <b-modal id="deleteCategoryModal" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
        <div class="error-wrapper p-3">
          <div class="mb-4 text-center">
            <img src="@/assets/images/checked1.svg" />
          </div>
          <div class="error-title text-center" style="font-size: 15px">آیا از اینکه محصول را حذف کنید اطمینان دارید؟</div>
          <div class="mt-3 float-right w-100">
            <div class="d-flex align-items-center justify-content-center mx-3">
              <b-button class="col-6" style="background-color: #74788d; color: white; font-size: 13px" variant="secondary" block @click="$bvModal.hide('deleteCategoryModal')"
                >انصراف</b-button
              >
              <b-button class="ms-2 col-6" style="background-color: #556ee6; color: white; font-size: 13px" variant="primary" block @click="deleteProduct()">تایید</b-button>
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal id="guaranteeCropperModal" no-close-on-esc hide-footer centered size="md" header-close-variant="dark" cancel-title>
        <div class="p-3">
          <ImageCropper :cropperLoading="cropperLoadingGuarantee" @imageSourceChanged="getGuaranteeImage($event)" />
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import PageHeader from '@/components/layoutComponents/page-header'
import BaseText from '../common/form/formModules/BaseText.vue'
import PriceInput from '../common/form/formModules/Price.vue'
import editorTextArea from '../common/form/formModules/editorInput.vue'
import TextAreaInput from '../common/form/formModules/TextAreaInput.vue'
import ImageCropper from '../user/ImageCropper.vue'
import fileMannager from '../../services/file'
import Button from '../../components/common/Button.vue'
import productAdvanceDataProvider from '../../services/productAdvance'
import Table from '../../components/common/table/simpleTable/SimpleTable.vue'
import Pagination from '../../components/common/table/simpleTable/Pagination.vue'
import { productMixins } from '../../utils/mixins'
import formBuilder from '../common/form/type/Editable.vue'
import ColorPicker from '../common/form/formModules/colorPicker.vue'
import ComboBox from '../common/form/formModules/ComboBox.vue'

export default {
  components: {
    PageHeader,
    BaseText,
    TextAreaInput,
    ImageCropper,
    editorTextArea,
    Button,
    ColorPicker,
    Table,
    Pagination,
    formBuilder,
    PriceInput,
    ComboBox,
  },
  mixins: [productMixins],
  data() {
    return {
      //loadings
      btnLoading: false,
      stopProductLoading: null,
      formbuilderKey: 1,
      cropperLoading: false,
      cropperLoadingBrand: false,
      cropperLoadingGuarantee: false,
      guranteeBtnLoading: false,
      sizeBtnLoading: false,
      colorBtnLoading: false,
      brandBtnLoading: false,
      //other
      productId: '',
      productPrice: null,
      productPriceError: false,
      stockQty: null,
      stockQtyError: false,
      productTitle: '',
      productUniqeId: '',
      productNote: '',
      productStory: '',
      showProduct: true,
      productStockActive: true,
      oldRecordId: null,
      dropDownListItems: [
        { id: 1, count: 10, value: 'نمایش 10 تایی', isDefault: true },
        { id: 2, count: 15, value: 'نمایش 15 تایی', isDefault: false },
        { id: 3, count: 20, value: 'نمایش 20 تایی', isDefault: false },
      ],
      tableView: true,
      showFormBuilder: false,
      //editor
      editorKey: 1,
      //brand
      brandPagination: null,
      brandPaginationData: 1,
      brandSearchedQuery: '',
      brandsApiPageNumber: 1,
      brandsData: [],
      newBrandName: '',
      brandImage: null,
      selectedBrand: {
        key: '',
        value: '',
      },
      brandError: false,
      //color
      colorError: false,
      colorPagination: null,
      colorPaginationData: 1,
      colorSearchedQuery: '',
      hasColor: false,
      colorsData: [],
      colorsApiPageNumber: 1,
      selectedColor: {
        key: '',
        value: '',
        code: '',
      },
      addSelectedColor: null,
      addColorName: null,
      //guarantee
      guaranteesError: false,
      guaranteePagination: null,
      guaranteePaginationData: 1,
      guaranteeSearchedQuery: '',
      hasGuarantee: false,
      guaranteesData: [],
      guaranteesApiPageNumber: 1,
      selectedGuarantee: {
        key: '',
        value: '',
      },
      guaranteeImage: [],
      addGuaranteeDuaration: null,
      addGuaranteeName: null,
      //size
      sizeError: false,
      sizePagination: null,
      sizePaginationData: 1,
      sizeSearchedQuery: '',
      hasSize: false,
      sizesData: [],
      sizesApiPageNumber: 1,
      selectedSize: {
        key: '',
        value: '',
      },
      addSizeName: null,
      //Provider
      providerError: false,
      providerPagination: null,
      providerPaginationData: 1,
      providerSearchedQuery: '',
      hasProvider: false,
      providerData: [],
      providerApiPageNumber: 1,
      selectedProvider: {
        key: '',
        value: '',
      },
      addProviderName: null,
      //categories
      categoryPagination: null,
      categoryPaginationData: 1,
      categorySearchedQuery: '',
      childrenCategoryPagination: [],
      childrenCategoryPaginationData: [1],
      childrenCategorySearchedQuery: '',
      mainCategories: [],
      grandCategoryApiPageNumber: 1,
      subCategoryHasMoreData: true,
      subCategoryApiPageNumber: 2,
      childrenCategory: [],
      childrensComboValue: [],
      selectedCategoryId: 0,
      selectedGrandCategory: '',
      formBuilderData: null,
      editCategoryName: '',
      categoryParents: [],
      //supplier
      selectedSupplier: '',
      //image cropper
      imageSource: [],
      activeImageIndex: null,
      activeImage: null,
      imageErrorFlag: false,
      //common
      showTable: true,
      editingStockId: null,
      isEditing: false,
      submitLoading: false,
      //errors
      productCodeError: false,
      productTitleError: false,
      headerItems: [
        {
          text: 'داشبورد',
          href: '/',
        },
        {
          text: 'اضافه کردن کالای جدید',
          active: true,
        },
      ],
      title: 'اضافه کردن کالا',
    }
  },
  mounted() {
    let temp = {
      categoryId: this.selectedCategoryId,
      query: this.categorySearchedQuery,
      pageNumber: this.categoryPaginationData,
    }
    this.getCategories(temp, 1)
    let brand = { query: this.brandSearchedQuery, pageNumber: this.brandPaginationData, pageSize: 10 }
    this.getBrands(brand, 1)
    if (this.$route.params.id) {
      this.showTable = false
      productAdvanceDataProvider.getProductAdvanceDetail(this.$route.params.id).then((res) => {
        this.showTable = true
        this.categoryParents = res.data.data.categoryParents.categoryParents
        const productResponseData = res.data.data.productData
        const tableResponseData = res.data.data.stockTable
        const formResponseData = res.data.data.formWithRecord

        this.formBuilderData = formResponseData.defaultValues === null ? null : formResponseData
        this.showFormBuilder = true
        this.selectedCategoryId = productResponseData.categoryId
        this.$store.dispatch('product/addFirstDataToTable', tableResponseData)
        setTimeout(() => {}, 1000)
        this.imageSource = productResponseData.imageUrls
        this.activeImage = productResponseData.imageUrl
        this.productStory = productResponseData.story
        this.productNote = productResponseData.description
        this.productId = productResponseData.code
        this.productTitle = productResponseData.name
        this.selectedBrand.value = productResponseData.brandName
        this.editCategoryName = productResponseData.categoryName
        this.selectedBrand.key = productResponseData.brandId
        this.oldRecordId = productResponseData.technicalPropertyRecordId
        this.productUniqeId = productResponseData.productId
        this.showProduct = productResponseData.isAvailable
        setTimeout(() => {
          this.editorKey += 1
        }, 300)
      })
    }
  },
  methods: {
    createNewColor() {
      this.colorBtnLoading = true
      productAdvanceDataProvider
        .addColor({
          name: this.addColorName,
          colorCode: this.addSelectedColor,
        })
        .then((res) => {
          this.selectedColor.key = res.data.data.color.id
          this.selectedColor.value = res.data.data.color.name
          this.colorsApiPageNumber = 1
          this.colorsData = []
          let color = { query: this.colorSearchedQuery, pageNumber: this.colorPaginationData, pageSize: 10 }
          this.getColors(color, 1)
          this.colorBtnLoading = false
          setTimeout(() => {
            this.$bvModal.hide('addColorModal')
            this.addColorName = null
            this.addSelectedColor = null
          }, 300)
        })
        .catch((err) => {
          this.colorBtnLoading = false
        })
    },
    createNewSize() {
      this.sizeBtnLoading = true
      productAdvanceDataProvider
        .addSize({
          size: this.addSizeName,
        })
        .then((res) => {
          this.selectedSize.key = res.data.data.size.id
          this.selectedSize.value = res.data.data.size.name
          this.sizesApiPageNumber = 1
          this.sizesData = []
          let size = { query: this.sizeSearchedQuery, pageNumber: this.sizePaginationData, pageSize: 10 }
          this.getSizes(size, 1)
          this.sizeBtnLoading = false
          setTimeout(() => {
            this.$bvModal.hide('addSizeModal')
            this.addSizeName = null
          }, 300)
        })
        .catch((err) => {
          this.sizeBtnLoading = false
        })
    },
    createNewGuarantee() {
      this.guranteeBtnLoading = true
      productAdvanceDataProvider
        .addGurantee({
          name: this.addGuaranteeName,
          duration: Number(this.addGuaranteeDuaration),
          frontImage: this.guaranteeImage[0],
          backImage: this.guaranteeImage[1],
        })
        .then((res) => {
          this.selectedGuarantee.key = res.data.data.guarantee.id
          this.selectedGuarantee.value = res.data.data.guarantee.name
          this.guaranteesApiPageNumber = 1
          this.guaranteesData = []
          let guarantees = { query: this.guaranteeSearchedQuery, pageNumber: this.guaranteePaginationData, pageSize: 10 }
          this.getGuarantees(guarantees, 1)
          this.$bvModal.hide('addGuaranteeModal')
          this.addGuaranteeName = null
          this.addGuaranteeDuaration = null
          this.guaranteeImage = []
          setTimeout(() => {
            this.guranteeBtnLoading = false
          }, 300)
        })
        .catch((err) => {
          this.guranteeBtnLoading = false
        })
    },
    deleteProduct() {
      productAdvanceDataProvider
        .deleteProduct({
          guid: this.$route.params.id,
        })
        .then((res) => {
          // this.$router.push({ path: '/list/productAdv' })
          this.$router.go(-1)
        })
    },
    hotUpdateStock() {
      let myStockItems = this.tableData.rows
      let stockItemsPayload = []
      myStockItems.map((item) => {
        let tableDataItems = {
          id: item.id ? item.id : '0',
          count: null,
          price: null,
          isAvailable: null,
          propItems: [],
        }
        item.items.map((data) => {
          if (data.fieldName == 'Count') {
            tableDataItems.count = data.value
          }
          if (data.fieldName == 'Price') {
            tableDataItems.price = data.value.split(',').join('')
          }
          // if (data.fieldName == 'Provider') {
          //   tableDataItems.provider = data.value
          // }
          if (data.fieldName == 'IsAvailable') {
            tableDataItems.isAvailable = data.value === 'فعال' ? true : false
          }
          if (data.fieldName === 'Guarantee') {
            tableDataItems.propItems.push({
              propertyId: data.id,
              propertyType: 2,
            })
          }
          if (data.fieldName === 'Size') {
            tableDataItems.propItems.push({
              propertyId: data.id,
              propertyType: 1,
            })
          }
          if (data.fieldName === 'Color') {
            tableDataItems.propItems.push({
              propertyId: data.id,
              propertyType: 0,
            })
          }
        })
        stockItemsPayload.push(tableDataItems)
      })
      productAdvanceDataProvider
        .editStock({
          guid: this.$route.params.id,
          stocksItems: stockItemsPayload,
        })
        .then((res) => {
          if (res.status === 200) {
            this.tableView = true
            this.showTable = true
            this.productStockActive = true
            this.selectedColor = {}
            this.selectedGuarantee = {}
            this.selectedSize = {}
            this.stockQty = ''
            this.productPrice = ''
            this.isEditing = false
            this.btnLoading = false
          }
        })
    },
    cancleStock() {
      this.tableView = true
      this.productPriceError = false
      this.stockQtyError = false
      this.colorError = false
      this.guaranteesError = false
      this.sizeError = false
    },
    stockTableRowSelected(payload) {
      const editing = payload.id ? this.tableData.rows.find((element) => payload.id === element.id) : this.tableData.rows.find((element) => payload.mockId === element.mockId)
      this.editingStockId = payload.id ? payload.id : payload.mockId
      this.isEditing = true
      this.tableView = false
      editing.items.forEach((e) => {
        if (e.fieldName === 'Guarantee') {
          this.selectedGuarantee.value = e.value
        }
        if (e.fieldName === 'Size') {
          this.selectedSize.value = e.value
        }
        if (e.fieldName === 'Color') {
          this.selectedColor.value = e.value
        }
        if (e.fieldName === 'Count') {
          this.stockQty = e.value
        }
        // if (e.fieldName === 'Provider') {
        //   this.selectedProvider.value = e.value
        // }
        if (e.fieldName === 'Price') {
          this.productPrice = this.Commafy(e.value)
        }
        if (e.fieldName === 'IsAvailable') {
          this.productStockActive = e.value === 'فعال' ? true : false
        }
      })
    },
    goUp() {
      this.stopProductLoading = true
      this.formbuilderKey += 1
      this.$refs.leftSection.scrollTop = 0
    },
    addNewStockToTable() {
      this.btnLoading = true
      setTimeout(() => {
        this.btnLoading = false
      }, 200)
      this.productPriceError = false
      this.stockQtyError = false
      this.colorError = false
      this.guaranteesError = false
      this.sizeError = false
      // this.providerError = false
      let needTofillInputs = false
      if (this.hasColor) {
        if (!this.selectedColor.value || this.selectedColor.value === '') {
          needTofillInputs = true
          this.colorError = true
        }
      }
      if (this.hasGuarantee) {
        if (!this.selectedGuarantee.value || this.selectedGuarantee.value === '') {
          needTofillInputs = true
          this.guaranteesError = true
        }
      }
      if (this.hasSize) {
        if (!this.selectedSize.value || this.selectedSize.value === '') {
          needTofillInputs = true
          this.sizeError = true
        }
      }
      // if ((!this.selectedProvider.value && this.tableData === null) || (this.selectedProvider.value === '' && this.tableData === null)) {
      //   needTofillInputs = true
      //   this.providerError = true
      // }
      if (!this.productPrice || this.productPrice == 0) {
        this.productPriceError = true
        needTofillInputs = true
      }
      if (!this.stockQty || this.stockQty == 0) {
        this.stockQtyError = true
        needTofillInputs = true
      }
      if (!needTofillInputs) {
        if (this.tableData !== null) {
          const rows = this.tableData.rows
          var payloadObject = {
            // id: Number(rows[rows.length - 1].id) + 1,
            mockId: Math.random() * 100,
            key: Number(rows[rows.length - 1].key) + 1,
            index: Number(rows[rows.length - 1].index) + 1,
            items: [
              {
                fieldName: 'Index',
                value: Number(rows[rows.length - 1].items[0].value) + 1,
                typeEnum: 0,
                type: 'Text',
                color: null,
                size: 10,
              },
              {
                fieldName: 'Count',
                value: this.stockQty,
                typeEnum: 0,
                type: 'Text',
                color: null,
                size: 15,
              },
              {
                fieldName: 'Price',
                value: this.productPrice.split(',').join(''),
                typeEnum: 2,
                type: 'Price',
                color: null,
                size: 15,
              },
              // {
              //   fieldName: 'Provider',
              //   value: this.selectedProvider.value,
              //   id: this.selectedProvider.key,
              //   typeEnum: 0,
              //   type: 'Text',
              //   color: null,
              //   size: 15,
              // },
              {
                fieldName: 'IsAvailable',
                value: this.productStockActive ? 'فعال' : 'غیر فعال',
                typeEnum: 5,
                type: 'Status',
                color: this.productStockActive ? 'rgb(52,195,143)' : 'rgb(244, 106, 106)',
                size: 20,
              },
            ],
          }
          if (this.hasSize) {
            payloadObject.items.splice(1, 0, {
              fieldName: 'Size',
              value: this.selectedSize.value,
              id: this.selectedSize.key,
              typeEnum: 0,
              type: 'Text',
              color: null,
            })
          }
          if (this.hasGuarantee) {
            payloadObject.items.splice(1, 0, {
              fieldName: 'Guarantee',
              value: this.selectedGuarantee.value,
              id: this.selectedGuarantee.key,
              typeEnum: 0,
              type: 'Text',
              color: null,
            })
          }
          if (this.hasColor) {
            payloadObject.items.splice(1, 0, {
              fieldName: 'Color',
              value: this.selectedColor.value,
              id: this.selectedColor.key,
              typeEnum: 9,
              type: 'Color',
              color: this.selectedColor.code,
            })
          }
        }
        const emptyTablePayloadObject = {
          fields: [
            {
              index: 1,
              order: 1,
              key: 'Index',
              label: '#',
              typeEnum: 0,
              type: 'Text',
              isCollection: false,
              statusColors: {},
              size: 5,
            },
            {
              index: 5,
              order: 5,
              key: 'Count',
              label: 'موجودی',
              typeEnum: 0,
              type: 'Text',
              isCollection: false,
              statusColors: {},
              size: 20,
            },
            {
              index: 6,
              order: 6,
              key: 'Price',
              label: 'قیمت فروش',
              typeEnum: 2,
              type: 'Price',
              isCollection: false,
              size: 20,
              statusColors: {},
            },
            // {
            //   index: 7,
            //   order: 7,
            //   key: 'Provider',
            //   label: 'تامین کننده',
            //   typeEnum: 0,
            //   type: 'Price',
            //   isCollection: false,
            //   size: 15,
            //   statusColors: {},
            // },
            {
              index: 7,
              order: 7,
              key: 'IsAvailable',
              label: 'وضعیت',
              typeEnum: 5,
              type: 'Status',
              isCollection: false,
              size: 20,
              statusColors: [{}, {}],
            },
          ],
          rows: [
            {
              id: '1',
              mockId: Math.random() * 100,
              key: '1',
              index: 1,
              items: [
                {
                  fieldName: 'Index',
                  value: 1,
                  typeEnum: 0,
                  type: 'Text',
                  color: null,
                  size: 5,
                },
                {
                  fieldName: 'Count',
                  value: this.stockQty,
                  typeEnum: 0,
                  type: 'Text',
                  color: null,
                  size: 15,
                },
                {
                  fieldName: 'Price',
                  value: this.productPrice.split(',').join(''),
                  typeEnum: 2,
                  type: 'Price',
                  color: null,
                  size: 15,
                },
                // {
                //   fieldName: 'Provider',
                //   value: this.selectedProvider.value,
                //   id: this.selectedProvider.key,
                //   typeEnum: 0,
                //   type: 'Text',
                //   color: null,
                //   size: 15,
                // },
                {
                  fieldName: 'IsAvailable',
                  value: this.productStockActive ? 'فعال' : 'غیر فعال',
                  typeEnum: 5,
                  type: 'Status',
                  color: this.productStockActive ? 'rgb(52,195,143)' : 'rgb(244, 106, 106)',
                  size: 20,
                },
              ],
            },
          ],
          filters: {},
        }
        if (this.hasSize) {
          emptyTablePayloadObject.fields.splice(1, 0, {
            index: 4,
            order: 4,
            key: 'Size',
            label: 'سایز',
            typeEnum: 0,
            type: 'Text',
            isCollection: false,
            statusColors: {},
          })
          emptyTablePayloadObject.rows[0].items.splice(1, 0, {
            fieldName: 'Size',
            value: this.selectedSize.value,
            id: this.selectedSize.key,
            typeEnum: 0,
            type: 'Text',
            color: null,
          })
        }
        if (this.hasGuarantee) {
          emptyTablePayloadObject.fields.splice(1, 0, {
            index: 3,
            order: 3,
            key: 'Guarantee',
            label: 'گارانتی',
            typeEnum: 0,
            type: 'Text',
            isCollection: false,
            statusColors: {},
          })
          emptyTablePayloadObject.rows[0].items.splice(1, 0, {
            fieldName: 'Guarantee',
            value: this.selectedGuarantee.value,
            id: this.selectedGuarantee.key,
            typeEnum: 0,
            type: 'Text',
            color: null,
          })
        }
        if (this.hasColor) {
          emptyTablePayloadObject.fields.splice(1, 0, {
            index: 2,
            order: 2,
            key: 'Color',
            label: 'رنگ',
            typeEnum: 9,
            type: 'Color',
            isCollection: false,
            statusColors: {},
          })
          emptyTablePayloadObject.rows[0].items.splice(1, 0, {
            fieldName: 'Color',
            value: this.selectedColor.value,
            id: this.selectedColor.key,
            typeEnum: 9,
            type: 'Color',
            color: this.selectedColor.code,
          })
        }
        if (this.tableData === null) {
          this.$store.dispatch('product/addFirstDataToTable', emptyTablePayloadObject)
        } else {
          if (this.editingStockId === null) {
            this.$store.dispatch('product/addNewStock', payloadObject)
            if (this.$route.params.id) {
              this.hotUpdateStock()
            }
          } else {
            const editStockPayload = [
              {
                fieldName: 'Count',
                value: this.stockQty,
                typeEnum: 0,
                type: 'Text',
                color: null,
                size: 10,
              },
              {
                fieldName: 'Price',
                value: this.productPrice.split(',').join(''),
                typeEnum: 2,
                type: 'Price',
                color: null,
              },
              // {
              //   fieldName: 'Provider',
              //   value: this.selectedProvider.value,
              //   id: this.selectedProvider.key,
              //   typeEnum: 0,
              //   type: 'Text',
              //   color: null,
              // },
              {
                fieldName: 'IsAvailable',
                value: this.productStockActive ? 'فعال' : 'غیر فعال',
                typeEnum: 5,
                type: 'Status',
                color: this.productStockActive ? 'rgb(52,195,143)' : 'rgb(244, 106, 106)',
              },
            ]
            this.$store.commit('product/EDIT_STOCK', { id: this.editingStockId, payload: editStockPayload })
            if (this.$route.params.id) {
              this.hotUpdateStock()
            }
          }
        }
        this.showTable = false
        setTimeout(() => {
          this.tableView = true
          this.showTable = true
          this.productStockActive = true
          this.selectedColor = {}
          this.selectedGuarantee = {}
          this.selectedSize = {}
          this.stockQty = ''
          this.productPrice = ''
        }, 800)
      }
    },
    submit(payload) {
      this.stopProductLoading = false
      this.imageErrorFlag = false
      this.productCodeError = false
      this.productTitleError = false
      this.brandError = false

      if (this.imageSource.length === 0) {
        setTimeout(() => {
          this.imageErrorFlag = true
          this.goUp()
        }, 200)
      }
      if (this.productTitle.length === 0) {
        this.productTitleError = true
        this.goUp()
      }
      if (this.productId.length === 0) {
        this.productCodeError = true
        this.goUp()
      }
      if (this.selectedBrand.value.length == 0 || !this.selectedBrand) {
        this.brandError = true
        this.goUp()
      }
      if (this.imageSource.length !== 0 && !this.productTitleError && !this.productCodeError && this.tableData === null) {
        this.stopProductLoading = true
        this.$bvModal.show('categorySelectError')
        this.stopProductLoading = true
        this.formbuilderKey += 1
      }
      if (this.imageSource.length !== 0 && !this.productTitleError && !this.productCodeError && this.tableData !== null) {
        this.submitLoading = true
        const stock = []
        this.tableData.rows.forEach((element) => {
          const color = element.items.find((e) => e.fieldName === 'Color')
          const size = element.items.find((e) => e.fieldName === 'Size')
          const guarantee = element.items.find((e) => e.fieldName === 'Guarantee')
          const price = element.items.find((e) => e.fieldName === 'Price')
          const count = element.items.find((e) => e.fieldName === 'Count')
          const isAvailable = element.items.find((e) => e.fieldName === 'IsAvailable')
          // const provider = element.items.find(e => e.fieldName === 'Provider')
          const id = element.id

          if (this.$route.params.id) {
            stock.push({
              id: id ? id : '0',
              count: count.value,
              price: Number(price.value.split(',').join('')),
              isAvailable: isAvailable.value === 'فعال' ? true : false,
              // supplierId: provider.id,
              minCount: 0, //
              maxCount: 0, //
              discount: 0, //
              propItems: [
                color
                  ? {
                      propertyId: color.id,
                      propertyType: 0, // 0 color, 1 size, 2 guarantee
                    }
                  : {},
                size
                  ? {
                      propertyId: size.id,
                      propertyType: 1, // 0 color, 1 size, 2 guarantee
                    }
                  : {},
                guarantee
                  ? {
                      propertyId: guarantee.id,
                      propertyType: 2, // 0 color, 1 size, 2 guarantee
                    }
                  : {},
              ],
            })
          } else {
            stock.push({
              count: count.value,
              price: Number(price.value.split(',').join('')),
              isAvailable: isAvailable.value === 'فعال' ? true : false,
              // supplierId: provider.id,
              minCount: 0, //
              maxCount: 0, //
              discount: 0, //
              propItems: [
                color
                  ? {
                      propertyId: color.id,
                      propertyType: 0, // 0 color, 1 size, 2 guarantee
                    }
                  : {},
                size
                  ? {
                      propertyId: size.id,
                      propertyType: 1, // 0 color, 1 size, 2 guarantee
                    }
                  : {},
                guarantee
                  ? {
                      propertyId: guarantee.id,
                      propertyType: 2, // 0 color, 1 size, 2 guarantee
                    }
                  : {},
              ],
            })
          }
        })
        let recordsData = []
        if (this.formBuilderData !== null) {
          let _temp = this.formBuilderData.defaultValues
          for (let i = 0; i < _temp.length; i++) {
            let data = {
              fieldId: _temp[i].id,
              fieldType: 1,
              value:
                _temp[i].value != null && typeof _temp[i].value === 'string'
                  ? _temp[i].value
                  : _temp[i].value != null && typeof _temp[i].value === 'boolean'
                  ? _temp[i].value.toString()
                  : '',
              subRecords: [],
              numberValue: _temp[i].value != null && typeof _temp[i].value === 'number' ? _temp[i].value : 0,
              dateValue: '2021-08-31T14:13:57.718Z',
              selectionIds: _temp[i].value != null && typeof _temp[i].value === 'object' ? [_temp[i].value] : [],
            }
            recordsData.push(data)
          }
        }
        //  let temp = this.formBuilderData.map(data => data.)

        if (this.$route.params.id) {
          productAdvanceDataProvider
            .editProductByGuid({
              guid: this.$route.params.id,
              code: this.productId,
              name: this.productTitle,
              imageUrls: this.imageSource,
              image: this.activeImage,
              description: this.productNote,
              story: this.productStory,
              brandId: this.selectedBrand.key,
              categoryId: this.selectedCategoryId,
              isAvailable: this.showProduct,
              provinceId: 0, //
              province: '', //
              cityId: 0, //
              city: '', //
              address: '', //
              mobile: '', //
              oldRecordId: this.oldRecordId,
              addRecordDto: {
                tenantId: 'string',
                serviceId: 'string',
                userId: 'string',
                formId: 'string',
                objectId: 'string',
                recordsData: recordsData,
              },
              stocksItems: stock,
            })
            .then((res) => {
              this.stopProductLoading = true
              this.submitLoading = false
              this.$router.go(-1)
            })
            .catch(() => {
              this.stopProductLoading = true
              this.submitLoading = false
            })
        } else {
          productAdvanceDataProvider
            .createProduct({
              userId: '', //
              code: this.productId,
              name: this.productTitle,
              userName: '', //
              userImageUrl: '', //
              userDescription: '', //
              imageUrls: this.imageSource,
              image: this.activeImage,
              description: this.productNote,
              story: this.productStory,
              brandId: this.selectedBrand.key,
              categoryId: this.selectedCategoryId,
              isAvailable: this.showProduct,
              provinceId: 0, //
              province: '', //
              cityId: 0, //
              city: '', //
              address: '', //
              mobile: '', //
              stocksItems: stock,
              technicalProperties: {
                addRecord: {
                  tenantId: '', //
                  serviceId: '', //
                  userId: '', //
                  objectId: '', //
                  recordsData: recordsData,
                },
              },
            })
            .then((res) => {
              this.stopProductLoading = true

              this.submitLoading = false
              this.$router.go(-1)
            })
            .catch(() => {
              this.stopProductLoading = true
              this.submitLoading = false
            })
        }
      }
    },
    showModalOfProperty(payload) {
      this.$bvModal.show(payload)
    },
    changeStockTableView() {
      if (this.showFormBuilder) {
        this.editingStockId = null
        this.tableView = false
        this.isEditing = false
        this.selectedSize = {}
        this.selectedGuarantee = {}
        this.selectedColor = {}
        this.selectedProvider = {}
        this.productStockActive = true
        this.productPrice = null
        this.stockQty = null
      } else {
        this.$bvModal.show('categorySelectError')
      }
    },
    getBrandImage(payload) {
      this.cropperLoadingBrand = true
      fileMannager
        .addImage({
          base64image: payload,
        })
        .then((res) => {
          this.cropperLoadingBrand = false
          this.brandImage = res.data.data.downloadUrl
          this.$bvModal.hide('brandCropperModal')
        })
    },
    getGuaranteeImage(payload) {
      this.cropperLoadingGuarantee = true
      fileMannager
        .addImage({
          base64image: payload,
        })
        .then((res) => {
          this.cropperLoadingGuarantee = false
          this.guaranteeImage.push(res.data.data.downloadUrl)
          this.$bvModal.hide('guaranteeCropperModal')
        })
    },
    searchedColors(event) {
      this.colorSearchedQuery = event
      this.colorPaginationData = 1
      let temp = {
        query: event,
        pageNumber: 1,
        pageSize: 10,
      }
      this.getColors(temp, 1)
    },
    loadMoreColors() {
      if (this.colorsData.length < this.colorPagination.totalCount) {
        this.colorPaginationData += 1
        let temp = {
          query: this.colorSearchedQuery,
          pageNumber: this.colorPaginationData,
          pageSize: 10,
        }
        this.getColors(temp, 0)
      } else {
        return
      }
    },
    getColors(data, situation) {
      productAdvanceDataProvider.getColors(data).then((res) => {
        this.colorPagination = res.data.pagination
        let temp = res.data.data.colors
        if (temp.length > 0) {
          for (let i = 0; i < temp.length; i++) {
            temp[i].value = temp[i]['name']
            temp[i].key = temp[i]['id']
            delete temp[i].name
            delete temp[i].id
            if (i === temp.length - 1) {
              if (situation === 1) {
                this.colorsData = temp
              } else if (situation === 0) {
                this.colorsData.push(...temp)
              }
            }
          }
        } else {
          this.colorsData = temp
          return
        }
      })
    },
    searchedGuarantees(event) {
      this.guaranteeSearchedQuery = event
      this.guaranteePaginationData = 1
      let temp = {
        query: event,
        pageNumber: 1,
        pageSize: 10,
      }
      this.getGuarantees(temp, 1)
    },
    loadMoreGuarantees() {
      if (this.guaranteesData.length < this.guaranteePagination.totalCount) {
        this.guaranteePaginationData += 1
        let temp = {
          query: this.guaranteeSearchedQuery,
          pageNumber: this.guaranteePaginationData,
          pageSize: 10,
        }
        this.getGuarantees(temp, 0)
      } else {
        return
      }
    },
    getGuarantees(data, situation) {
      productAdvanceDataProvider.getGuarantees(data).then((res) => {
        this.guaranteePagination = res.data.pagination
        let temp = res.data.data.guarantees
        if (temp.length > 0) {
          for (let i = 0; i < temp.length; i++) {
            temp[i].value = temp[i]['name']
            temp[i].key = temp[i]['id']
            delete temp[i].name
            delete temp[i].id
            if (i === temp.length - 1) {
              if (situation === 1) {
                this.guaranteesData = temp
              } else if (situation === 0) {
                this.guaranteesData.push(...temp)
              }
            }
          }
        } else {
          this.guaranteesData = temp
          return
        }
      })
    },
    // searchedProvider(event) {
    //   this.providerSearchedQuery = event
    //   this.providerPaginationData = 1
    //   let temp = {
    //     keyword: event,
    //     pageNumber: 1,
    //     pageSize: 10,
    //   }
    //   this.getProvider(temp, 1)
    // },
    // loadMoreProvider() {
    //   if (this.providerData.length < this.providerPagination.totalCount) {
    //     this.providerPaginationData += 1
    //     let temp = {
    //       keyword: this.providerSearchedQuery,
    //       pageNumber: this.providerPaginationData,
    //       pageSize: 10,
    //     }
    //     this.getProvider(temp, 0)
    //   } else {
    //     return
    //   }
    // },
    // getProvider(data, situation) {
    //   productAdvanceDataProvider.getCustomer(data).then((res) => {
    //     console.log('getCustomer', res.data)
    //     this.providerPagination = res.data.pagination
    //     let temp = res.data.data.people
    //     if (temp.length > 0) {
    //       for (let i = 0; i < temp.length; i++) {
    //         if (i === temp.length - 1) {
    //           if (situation === 1) {
    //             this.providerData = temp
    //           } else if (situation === 0) {
    //             this.providerData.push(...temp)
    //           }
    //         }
    //       }
    //     } else {
    //       this.providerData = temp
    //       return
    //     }
    //   })
    // },
    searchedSize(event) {
      this.sizeSearchedQuery = event
      this.sizePaginationData = 1
      let temp = {
        query: event,
        pageNumber: 1,
        pageSize: 10,
      }
      this.getSizes(temp, 1)
    },
    loadMoreSize() {
      if (this.sizesData.length < this.sizePagination.totalCount) {
        this.sizePaginationData += 1
        let temp = {
          query: this.sizeSearchedQuery,
          pageNumber: this.sizePaginationData,
          pageSize: 10,
        }
        this.getSizes(temp, 0)
      } else {
        return
      }
    },
    getSizes(data, situation) {
      productAdvanceDataProvider.getSize(data).then((res) => {
        this.sizePagination = res.data.pagination
        let temp = res.data.data.sizes
        if (temp.length > 0) {
          for (let i = 0; i < temp.length; i++) {
            temp[i].value = temp[i]['name']
            temp[i].key = temp[i]['id']
            delete temp[i].name
            delete temp[i].id
            if (i === temp.length - 1) {
              if (situation === 1) {
                this.sizesData = temp
              } else if (situation === 0) {
                this.sizesData.push(...temp)
              }
            }
          }
        } else {
          this.sizesData = temp
          return
        }
      })
    },
    searchedBrands(event) {
      this.brandSearchedQuery = event
      this.brandPaginationData = 1
      let temp = {
        query: event,
        pageNumber: 1,
        pageSize: 10,
      }
      this.getBrands(temp, 1)
    },
    loadMoreBrands() {
      if (this.brandsData.length < this.brandPagination.totalCount) {
        this.brandPaginationData += 1
        let temp = {
          query: this.brandSearchedQuery,
          pageNumber: this.brandPaginationData,
          pageSize: 10,
        }
        this.getBrands(temp, 0)
      } else {
        return
      }
    },
    getBrands(data, situation) {
      productAdvanceDataProvider.getBrands(data).then((res) => {
        this.brandPagination = res.data.pagination
        let temp = res.data.data.productBrandsDto
        if (temp.length > 0) {
          for (let i = 0; i < temp.length; i++) {
            temp[i].value = temp[i]['name']
            temp[i].key = temp[i]['id']
            delete temp[i].name
            delete temp[i].id
            if (i === temp.length - 1) {
              if (situation === 1) {
                this.brandsData = temp
              } else if (situation === 0) {
                this.brandsData.push(...temp)
              }
            }
          }
        } else {
          this.brandsData = temp
          return
        }
      })
    },
    searchedCategory(event) {
      this.categorySearchedQuery = event
      this.categoryPaginationData = 1
      let temp = {
        query: event,
        pageNumber: 1,
        pageSize: 10,
      }
      this.getCategories(temp, 1)
    },
    loadMoreCategories() {
      if (this.mainCategories.length < this.categoryPagination.totalCount) {
        this.categoryPaginationData += 1
        let temp = {
          query: this.categorySearchedQuery,
          pageNumber: this.categoryPaginationData,
          pageSize: 10,
        }
        this.getCategories(temp, 0)
      } else {
        return
      }
    },
    getCategories(data, situation) {
      productAdvanceDataProvider.getCategories(data).then((res) => {
        this.categoryPagination = res.data.pagination
        let temp = res.data.data.categories
        if (temp.length > 0) {
          for (let i = 0; i < temp.length; i++) {
            temp[i].value = temp[i]['name']
            temp[i].key = temp[i]['categoryId']
            delete temp[i].name
            delete temp[i].categoryId
            if (i === temp.length - 1) {
              this.showTree = true
              if (situation === 1) {
                this.mainCategories = temp
              } else if (situation === 0) {
                this.mainCategories.push(...temp)
              }
            }
          }
        } else {
          this.mainCategories = temp
          return
        }
      })
    },
    searchedChildrenCategory(event, index) {
      this.childrenCategorySearchedQuery = event
      this.childrenCategoryPaginationData[index] = 1
      let temp = {
        categoryId: this.childrenCategory[index].id,
        query: event,
        pageNumber: 1,
        pageSize: 10,
      }
      productAdvanceDataProvider.getCategories(temp).then((res) => {
        this.childrenCategoryPagination[index] = res.data.pagination
        let template = res.data.data.categories
        if (template.length > 0) {
          for (let i = 0; i < template.length; i++) {
            template[i].value = template[i]['name']
            template[i].key = template[i]['categoryId']
            delete template[i].name
            delete template[i].categoryId
            if (i === template.length - 1) {
              this.childrenCategory[index].arr = template
            }
          }
        } else {
          this.childrenCategory[index].arr = []
        }
      })
    },
    subCategoriesWithPagination(index) {
      if (this.childrenCategory[index].arr.length < this.childrenCategoryPagination[index].totalCount) {
        this.childrenCategoryPaginationData.splice(index, 0, 1)
        this.childrenCategoryPaginationData[index] += 1
        let temp = {
          categoryId: this.selectedCategoryId,
          query: this.childrenCategorySearchedQuery,
          pageNumber: this.childrenCategoryPaginationData[index],
          pageSize: 10,
        }
        productAdvanceDataProvider.getCategories(temp).then((res) => {
          this.categoryPagination = res.data.pagination
          let template = res.data.data.categories
          if (template.length > 0) {
            for (let i = 0; i < template.length; i++) {
              template[i].value = template[i]['name']
              template[i].key = template[i]['categoryId']
              delete template[i].name
              delete template[i].categoryId
            }
            this.childrenCategory[index].arr.push(...template)
          }
        })
      } else {
        return
      }
    },
    getCategoryFormBuilderWithId(payload) {
      productAdvanceDataProvider.getCategoryFormBuilderWithId({ categoryId: payload }).then((res) => {
        this.formBuilderData = res.data.data && res.data.data.defaultValues !== null ? res.data.data : null
        this.formbuilderKey += 1
      })
    },
    createNewBrand() {
      this.brandBtnLoading = true
      productAdvanceDataProvider
        .createBrand({ name: this.newBrandName, icon: this.brandImage })
        .then((res) => {
          this.selectedBrand.value = this.newBrandName
          this.selectedBrand.key = res.data.data.brandId
          this.newBrandName = null
          this.brandImage = null
          this.brandsData = []
          this.brandsApiPageNumber = 1
          let brand = { query: this.brandSearchedQuery, pageNumber: this.brandPaginationData, pageSize: 10 }
          this.getBrands(brand, 1)
          this.brandBtnLoading = false
          setTimeout(() => {
            this.$bvModal.hide('AddBrandModal')
          }, 300)
        })
        .catch((err) => {
          this.brandBtnLoading = false
        })
    },
    getCategoryChilds(e) {
      this.childrenCategoryPaginationData = [1]
      this.categoryPaginationData = 1
      this.childrenCategory = []
      this.childrensComboValue = []
      this.showFormBuilder = false
      this.selectedGrandCategory = e.value
      this.selectedCategoryId = e.key
      let temp = {
        categoryId: this.selectedCategoryId,
        query: this.childrenCategorySearchedQuery,
        pageNumber: 1,
        pageSize: 10,
      }
      productAdvanceDataProvider.getCategories(temp).then((res) => {
        this.childrenCategoryPagination.push(res.data.pagination)
        if (res.data.data.categories.length === 0) {
          this.showFormBuilder = true
          this.getCategoryFormBuilderWithId(this.selectedCategoryId)
          // this.getCategoryFormBuilderWithId(6)
        }
        if (res.data.data.categories.length !== 0) {
          let myData = res.data.data.categories
          if (myData.length > 0) {
            for (let i = 0; i < myData.length; i++) {
              myData[i].value = myData[i]['name']
              myData[i].key = myData[i]['categoryId']
              delete myData[i].name
              delete myData[i].categoryId
            }
          }
          this.childrenCategory.push({ arr: myData, id: this.selectedCategoryId })
        }
      })
    },
    getChildren(data, index) {
      this.subCategoryHasMoreData = true
      this.subCategoryApiPageNumber = 1
      this.showFormBuilder = false
      this.childrensComboValue = this.childrensComboValue.filter((w, i) => i < index)
      this.childrenCategory = this.childrenCategory.filter((w, i) => i <= index)
      this.selectedCategoryId = data.key
      this.childrensComboValue.push(data.value)
      let temp = {
        categoryId: this.selectedCategoryId,
        query: this.childrenCategorySearchedQuery,
        pageNumber: this.subCategoryApiPageNumber,
        pageSize: 10,
      }
      productAdvanceDataProvider.getCategories(temp).then((res) => {
        if (res.data.data.categories.length === 0) {
          this.showFormBuilder = true

          this.getCategoryFormBuilderWithId(this.selectedCategoryId)
          // this.getCategoryFormBuilderWithId(6)
        }
        if (res.data.data.categories.length !== 0) {
          this.childrenCategoryPagination.splice(index + 1, 0, res.data.pagination)
          let myData = res.data.data.categories
          if (myData.length > 0) {
            for (let i = 0; i < myData.length; i++) {
              myData[i].value = myData[i]['name']
              myData[i].key = myData[i]['categoryId']
              delete myData[i].name
              delete myData[i].categoryId
            }
          }
          this.childrenCategory.push({ arr: myData, id: this.selectedCategoryId })
        }
      })
    },
    addImageToListOfImages(payload) {
      this.cropperLoading = true
      fileMannager
        .addImage({
          base64image: payload,
        })
        .then((res) => {
          this.cropperLoading = false

          this.imageSource.push(res.data.data.downloadUrl)
          this.$bvModal.hide('cropperModal')
        })
    },
    removeImage(payload) {
      if (payload === this.activeImageIndex) {
        this.activeImage = null
        this.activeImageIndex = null
      }
      this.imageSource.splice(payload, 1)
    },
    setActiveImage(payload) {
      this.activeImageIndex = payload
      this.activeImage = this.imageSource[payload]
    },
    changePriceValue(payload) {
      let test = Number(payload).toLocaleString()
      return test
    },
    cancelButton() {
      this.$router.go(-1)
    },
    getPropertiesForCategory() {
      ///// get Providet Data
      // let provider = { keyword: this.colorSearchedQuery, pageNumber: this.colorPaginationData, pageSize: 10 }
      // this.getProvider(provider, 1)
      ///// Get size, garantee and color Data
      this.hasGuarantee = false
      this.hasSize = false
      this.hasColor = false
      productAdvanceDataProvider.getCategoryProperties({ categoryId: this.selectedCategoryId }).then((res) => {
        res.data.data.propertyTypes.forEach((element) => {
          if (element.propertyType === 0) {
            this.hasColor = true
            let color = { query: this.colorSearchedQuery, pageNumber: this.colorPaginationData, pageSize: 10 }
            this.getColors(color, 1)
          }
          if (element.propertyType === 1) {
            this.hasSize = true
            let size = { query: this.sizeSearchedQuery, pageNumber: this.sizePaginationData, pageSize: 10 }
            this.getSizes(size, 1)
          }
          if (element.propertyType === 2) {
            this.hasGuarantee = true
            let guarantees = { query: this.guaranteeSearchedQuery, pageNumber: this.guaranteePaginationData, pageSize: 10 }
            this.getGuarantees(guarantees, 1)
          }
        })
      })
    },
  },
  beforeDestroy() {
    this.$store.dispatch('product/setTableData', null)
  },
  watch: {
    // showFormBuilder(newVal) {
    //   if (newVal === true) {
    //     this.getPropertiesForCategory()
    //   }
    // },
    imageSourceLength(val) {
      if (val === 1) {
        this.activeImageIndex = 0
        this.activeImage = this.imageSource[0]
      }
    },
    activeImage(newVal) {
      if (newVal === null || newVal === undefined) {
        this.activeImageIndex = 0
        this.activeImage = this.imageSource[0]
      }
    },
    selectedCategoryId(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (!this.$route.params.id) {
          this.$store.dispatch('product/setTableData', null)
        }
        this.getPropertiesForCategory()
        if (!this.$route.params.id) {
          this.showFormBuilder = false
          this.tableView = true
        }
      }
    },
  },
  computed: {
    imageSourceLength() {
      return this.imageSource.length
    },
  },
}
</script>
<style scoped lang="scss">
@import './styles/productAdvance.scss';
::v-deep .addColorClass {
  text-align: right !important;
}
</style>
